import React from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { AiFillCheckCircle } from "react-icons/ai";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import ResultPage from "../../../components/ResultPage/ResultPage";

const BindSuccess = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`formHint.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const navigate = useNavigate();
  return (
    <ResultPage
      buttonProps={{
        content: i18n_common("backToHome"),
        path: "/casino",
      }}
      resultContent={`${i18n("youCanGo")} ${i18n("bindRoute")}，${i18n(
        "change"
      )}
          ${i18n("bindData")}`}
      resultText={i18n("bindSuccess")}
      pageType="success"
      pageTitle={i18n("bindSuccess")}
    />
  );
};

export default BindSuccess;
